import { AuthSelectors, RoleEnum } from '@anecdotes/auth-core';
import { createSelector } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';
import { ExtendedUser } from '../../../../models';
import { SelectUserState } from '../select-user-state';

export const SelectCalculatedUsersDictionary = createSelector(
  SelectUserState,
  AuthSelectors.currentUserSelector,
  (usersState, currentUser) => {
    if (!usersState.isLoaded || !currentUser) {
      return null;
    }

    const result: Dictionary<ExtendedUser> = {};

    Object.entries(usersState.entities).forEach(([key, user]) => {
      let role = user.role;

      if (role === RoleEnum.Manager) {
        role = RoleEnum.Collaborator;
      }

      const extendedUser: ExtendedUser = {
        ...user,
        role,
        is_current_user: user.uid === currentUser.user_id,
        full_name: [user.first_name, user.last_name].filter(Boolean).join(' '),
      };

      result[key] = extendedUser;
    });

    return result;
  },
);
